import { render, staticRenderFns } from "./voice-room-detail.vue?vue&type=template&id=5efdbb70&scoped=true&"
import script from "./voice-room-detail.vue?vue&type=script&lang=js&"
export * from "./voice-room-detail.vue?vue&type=script&lang=js&"
import style0 from "./voice-room-detail.vue?vue&type=style&index=0&id=5efdbb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdbb70",
  null
  
)

export default component.exports